__turbopack_context__.v({
  "cardPrimaryAction": "interaction-module-scss-module__KekS8q__cardPrimaryAction",
  "itemCard": "interaction-module-scss-module__KekS8q__itemCard",
});
